import { DepositRequest } from '@shared/model/deposit-request.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestBankIdData } from '@shared/model/request-banck-id.model';
import { RequestBankData } from '@shared/model/request-bank.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DepositRequestById } from '@shared/model/deposit-request-id.model';
import { ResponseBody } from '@shared/model/response-body.models';
import { withdrawRequest } from '@shared/model/withdrow-request';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class PeymentService {
  private readonly baseUrl = environment.baseUrl;
  private readonly routePrefix = 'api/v1/admin';

  constructor(private http: HttpClient , private snackBar: MatSnackBar) { }
  requestBankAccount(
    startPage: number,
    pageSize: number
  ): Observable<RequestBankData[]> {
    return this.http
      .get(
        `${this.baseUrl}/${this.routePrefix}/payment/request-bank-account?startPage=${startPage}&pageSize=${pageSize}`
      )
      .pipe(map((res: any) => res.data));
  }

  requestBankAccountById(id: number): Observable<RequestBankIdData> {
    return this.http
      .get(`${this.baseUrl}/${this.routePrefix}/payment/${id}/request-bank-account`)
      .pipe(map((res: any) => res.data));
  }

  depositRequest(
    startPage: number,
    pageSize: number
  ): Observable<DepositRequest> {
    return this.http
      .get(
        `${this.baseUrl}/${this.routePrefix}/payment/deposit-requests?startPage=${startPage}&pageSize=${pageSize}`
      )
      .pipe(map((res: any) => res.data));
  }

  DepositRequestById(id: number): Observable<DepositRequestById> {
    return this.http
      .get(`${this.baseUrl}/${this.routePrefix}/payment/deposit-requests/${id}`)
      .pipe(map((res: any) => res.data));
  }

  postRequestBankAccount(body): Observable<ResponseBody> {
    return this.http.post(`${this.baseUrl}/${this.routePrefix}/payment/request-bank-account`, body)
    .pipe(map(
      (res: any) => {
        if(res.status === 200){
          this.snackBar.open(res.message , 'Undo', {
            duration: 1000
          })
          return  res;
        }
        else{
          this.snackBar.open(res.message , 'Undo', {
            duration: 1000
          })
        }
      }
     ));
  }

  postDepositRequest(body): Observable<ResponseBody> {
    return this.http.post(`${this.baseUrl}/${this.routePrefix}/payment/deposit-request`, body)
    .pipe(map(
      (res: any) => {
        if(res.status === 200){
          this.snackBar.open(res.message , 'Undo', {
            duration: 1000
          })
          return res
        }
        else{
          this.snackBar.open(res.message , 'Undo', {
            duration: 1000
          })
        }
      }
       ));
  }

  withdrawRequest(
    startPage: number,
    pageSize: number
  ): Observable<withdrawRequest> {
    return this.http
      .get(
        `${this.baseUrl}/${this.routePrefix}/payment/withdraw-requests?startPage=${startPage}&pageSize=${pageSize}`
      )
      .pipe(map((res: any) => res.data));
  }

  postWithdraw(body){
    return this.http.post(`${this.baseUrl}/${this.routePrefix}/payment/withdraw-requests`, body)
    .pipe(map(
      (res: any) =>{
        if(res.status === 200 ){
          this.snackBar.open(res.message , 'Undo', {
            duration: 1000
          })
          return res
        }else{
          this.snackBar.open(res.message , 'Undo', {
            duration: 1000
          })
        }
      }
      ));
  }
}
